module.exports = __webpack_public_path__ + "img/CM-MC-25-Hyundai-Lifestyle.ac3013a7.jpg";